import { combineReducers } from "redux";
import usersReducer from "./users.reducer";
import alertReducer from "./alert.reducer";
import kycReducer from "./kycVerificationList.reducer";
import TransactionReducer from "./TransactionList.reducer";
import activeUserList from "./activeUserList.reducers";
import replyMsgTicketAdminReducers from "./ContactUs.reducers";
import getDashBoardData from "./activeUserList.reducers"
import getsecurityQuestionsList from "./securityQuestions.reducers";
import getCoinManagementList from "./coinManagement.reducers";
import disputeManagementReducers from './disputeManagement.reducers';
import paymentMethodListReducers from "./paymentMethod.reducers";
import appSettingListReducers from "./appsetting.reducer";
import userListsReducers from "./userManagement.reducers";
import adminUsersReducers from "./adminUsers.reducers"
import monitoringUnitsReducers from "./monitoring.reducers"


const rootReducer = combineReducers({
  users: usersReducer,
  alert: alertReducer,
  kyc: kycReducer,
  Tnx: TransactionReducer,
  activeUserList: activeUserList,
  supportReply: replyMsgTicketAdminReducers,
  getDashboard: getDashBoardData,
  securityQue: getsecurityQuestionsList,
  getCoin: getCoinManagementList,
  disputeManagement: disputeManagementReducers,
  paymentMethod: paymentMethodListReducers,
  appsetting: appSettingListReducers,
  userManagement: userListsReducers,
  adminUsers: adminUsersReducers,
  monitoringUnits: monitoringUnitsReducers


});

export default rootReducer;
